export default function (value) {
  if (!value && value !== 0) return ''
  return '€ ' + value.toFixed(2)
}



// WEBPACK FOOTER //
// ./src/filters/money.js